<div class="edit-modal kw-dialog">

  <div class="modal-header">
    <div class="header-titles">
      <h2 class="modal-title">Move Multiple</h2>
      <div class="modal-subtitle">Choose how you want to move the selected inventory</div>
    </div>
    <button mat-icon-button class="close-btn" type="button" aria-label="Close" (click)="cancel()">
      <fa-icon [icon]="faTimes"></fa-icon>
    </button>
  </div>

  <div class="modal-body">
    <div class="option-list">
      <button type="button" class="option-card" (click)="navigateToLocation()">
        <span class="option-icon"><fa-icon [icon]="faWarehouse"></fa-icon></span>
        <span class="option-text">
          <span class="option-name">Move to Location</span>
          <span class="option-sub">Move inventory to a warehouse, room, or location</span>
        </span>
        <fa-icon [icon]="faChevronRight" class="option-chevron"></fa-icon>
      </button>

      <button type="button" class="option-card" (click)="navigateToOrder()">
        <span class="option-icon"><fa-icon [icon]="faFileLines"></fa-icon></span>
        <span class="option-text">
          <span class="option-name">Move to Order</span>
          <span class="option-sub">Assign inventory to a specific order with quantities</span>
        </span>
        <fa-icon [icon]="faChevronRight" class="option-chevron"></fa-icon>
      </button>
    </div>
  </div>

  <div class="modal-footer">
    <button mat-stroked-button type="button" (click)="cancel()">Cancel</button>
  </div>

</div>
